import React from 'react'

import EditServiceOrderModal from './EditServiceOrderModal'

const EditServiceOrderPage = props => {
  return <EditServiceOrderModal noOverlay onClose={false} {...props} />
}

export default EditServiceOrderPage
